import { Injectable } from '@angular/core';
import { debounceTime, fromEvent, map, Observable, startWith } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BrowserService {
  screenSizeChanged(size: number): Observable<boolean> {
    const checkScreenSize = () => document.body.offsetWidth < size;
    const screenSizeChanged$ = fromEvent(window, 'resize').pipe(debounceTime(10)).pipe(map(checkScreenSize));

    return screenSizeChanged$.pipe(startWith(checkScreenSize()));
  }
}
